import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

export const PairSearchItemSkeleton: React.FC = () => {
  return (
    <Root>
      <Headline>
        <Skeleton height={16} width={16} variant="circular" />
        <IconImage height={40} width={40} variant="rectangle" />
        <InfoBlock>
          <Skeleton height={14} width="50%" />
          <Skeleton height={12} width="80%" />
        </InfoBlock>
        <MarketCap height={48} width={56} />
      </Headline>
      <Metrics>
        <Skeleton height={14} width={36} />
        <Skeleton height={14} width={40} />
        <Skeleton height={14} width={40} />
        <Skeleton height={14} width={36} />
        <Skeleton height={14} width={44} />
      </Metrics>
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  display: grid;
  align-items: center;

  border-radius: 12px;
  border: 1px solid var(--backgroundA-3);
  background: var(--background-2);
`

const Headline = styled.div`
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr) auto;
  align-items: center;
  padding-block: 3px;
  padding-inline: 8px 3px;
  gap: 4px;
`

const IconImage = styled(Skeleton)`
  border-radius: 10px;
`

const InfoBlock = styled.div`
  display: grid;
  gap: 4px;
  padding-inline: 4px;
`

const MarketCap = styled(Skeleton)`
  border-radius: 10px;
`

const Metrics = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-top: 1px solid var(--backgroundA-2);
  padding-block: 3px 4px;
  padding-inline: 9px;
`
